import { operatorTypes } from './operators.types';

export const inviteOperatorStart = (operator) => ({
  type: operatorTypes.INVITE_OPERATORS_START,
  payload: operator,
});

export const fetchOperatorsStart = () => ({
  type: operatorTypes.FETCH_OPERATORS_START,
});

export const editOperatorProfileStart = (operatorCredentials) => ({
  type: operatorTypes.EDIT_OPERATOR_PROFILE_START,
  payload: operatorCredentials,
});

export const removeOperatorStart = (operatorId) => ({
  type: operatorTypes.REMOVE_OPERATOR_START,
  payload: operatorId,
});

export const updateRemovedOperator = (operatorId) => ({
  type: operatorTypes.UPDATE_REMOVED_OPERATOR,
  payload: operatorId,
});

export const editOperatorStart = (crednetials) => ({
  type: operatorTypes.EDIT_OPERATOR_START,
  payload: crednetials,
});

export const validateEnteredVerificationCode = ({ code, mobile }) => ({
  type: operatorTypes.VALIDATE_ENTERED_VERIFICATION_CODE,
  payload: { code, mobile },
});

export const setOperators = (operators) => ({
  type: operatorTypes.SET_OPERATORS,
  payload: operators,
});

export const loadingOperators = () => ({
  type: operatorTypes.LOADING_OPERATORS,
});

export const setCurrentOperator = (operatorId) => ({
  type: operatorTypes.SET_CURRENT_OPERATOR,
  payload: operatorId,
});

export const changeOperatorMobileNumber = ({
  mobile,
  operatorId,
  onSuccess,
}) => ({
  type: operatorTypes.CHANGE_OPERATOR_MOBILE_NUMBER,
  payload: { mobile, operatorId, onSuccess },
});

export const resetCurrentOperator = () => ({
  type: operatorTypes.RESET_CURRENT_OPERATOR,
});

export const setEditedOperator = (operator) => ({
  type: operatorTypes.SET_EDITED_OPERATOR,
  payload: operator,
});

export const saveToEditedOperator = (operator) => ({
  type: operatorTypes.SAVE_TO_EDITED_OPERATOR,
  payload: operator,
});

export const fetchOperatorReportsStart = (operatorId) => ({
  type: operatorTypes.FETCH_OPERATOR_REPORTS_START,
  payload: operatorId,
});

export const setOperatorReports = (operatorReports) => ({
  type: operatorTypes.SET_OPERATOR_REPORTS,
  payload: operatorReports,
});

export const fetchOperatorsBetweenDaysStart = ({ start_date, end_date }) => ({
  type: operatorTypes.FETCH_OPERATORS_BETWEEN_DAYS_START,
  payload: {
    start_date,
    end_date,
  },
});

export const setOperatorsTableData = (data) => ({
  type: operatorTypes.SET_OPERATORS_TABLE_DATA,
  payload: data,
});

export const setWeeklyChosenOperator = (data) => ({
  type: operatorTypes.SET_WEEKLY_CHOSEN_OPERATOR,
  payload: data,
});

export const fetchWeeklyChosenOperatorStart = () => ({
  type: operatorTypes.FETCH_WEEKLY_CHOSEN_OPERATOR,
});

export const loadingWeeklyChosenOperatorStart = () => ({
  type: operatorTypes.LOADING_WEEKLY_CHOSEN_OPERATOR,
});

// for statistics

export const fetchSortedOperatorsListStart = ({ start_date, end_date }) => {
  return {
    type: operatorTypes.FETCH_SORTED_OPERATORS_LIST_START,
    payload: {
      start_date,
      end_date,
    },
  };
};

export const setSortedOperatorsList = (list, metrics) => ({
  type: operatorTypes.SET_SORTED_OPERATORS_LIST,
  payload: {
    list,
    metrics,
  },
});

export const loadingSortedOperatorsList = (value) => ({
  type: operatorTypes.LOADING_SORTED_OPERATORS_LIST_START,
  payload: value,
});
